/**
 * api-控制面板页
 */
import { post } from '@/utils/http'

// 修改密码
export const apiChangePwd = p => post('/admin/changePwd.do', p)
// 获取管理人员列表
export const apiGetAdminList = p => post('/admin/getAdminList.do', p)
// 新增管理人员
export const apiAddAdmin = p => post('/admin/addAdmin.do', p)
// 删除管理员
export const apiDelAdmin = p => post('/admin/delAdmin.do', p)
// 修改管理员信息
export const apiEditAdmin = p => post('/admin/editAdmin.do', p)
// 获取版本号
export const apiGetVersion = p => post('/BIndex/getVersion.do', p)
// 更新版本号
export const apiUploadVersion = p => post('/BIndex/uploadVersion.do', p)
